import { SourceDto, VideoDto } from './video.dto';

export class Video {
    id: string;
    sources: Source[];

    constructor(data: VideoDto) {
        this.id = data.id ?? '';
        this.sources = data.sources.map((source) => new Source(source));
    }
}

export class Source {
    src: string;
    type: 'video/mp4';
    constructor(data: SourceDto) {
        this.src = data.src ?? '';
        if (data.type === 'video/mp4') {
            this.type = data.type;
        } else {
            throw new Error('incompatible-source');
        }
    }
}
